import { english } from "./english";
import { hindi } from "./hindi";


export const langProvider={
    en:english,
    hi:hindi
}

export const userLang="en"